import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'atoms/Modal';

import StyledPauseMatchModal from './StyledPauseMatchModal';
import Button, { SecondaryButton } from 'styled/components/Button';

import { ModalProps } from 'atoms/Modal/ModalTypes';

import { modalsSlice } from 'features/modals/modalsSlice';
import { halfTimeExtraTime } from 'features/match/thunks';
import { useAppDispatch } from '../../../hooks/hooks';

const HalfTimeExtraTimeModal: React.FC<ModalProps> = (props) => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(modalsSlice.actions.setHalfTimeExtraTimeModal(false));
  };

  return (
    <Modal {...props}>
      <StyledPauseMatchModal>
        <div />
        <div className="text">
          <FormattedMessage id="modals.halfTimeExtraTime" />
        </div>
        <div className="actions">
          <Button
            onClick={() => {
              dispatch(halfTimeExtraTime({}));
              close();
            }}
          >
            <FormattedMessage id="buttons.halfTimeExtraTime" />
          </Button>
          <SecondaryButton whiteBackground greenText onClick={close}>
            <FormattedMessage id="buttons.cancel" />
          </SecondaryButton>
        </div>
      </StyledPauseMatchModal>
    </Modal>
  );
};

export default HalfTimeExtraTimeModal;
